export default __webpack_public_path__ + "static/media/GPA_Mawar_Background.86fa70d1.jpg";